import { CSSProperties, FC, useCallback, useMemo } from 'react'

import { FontWeight } from '@hhgtech/hhg-components/mantine'
import { useMantineTheme } from '@mantine/core'
import Link from 'next/link'
import { useIntl } from 'react-intl'

import { getHelloSitesUrl } from 'api/utils/paths'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { DataAttributeKey } from 'interfaces/types'
import {
  AuthorFormatMessage,
  AuthorFormatMessageOptionsKeys,
} from 'utils/author'

export type CardArticleAuthorNameProps = AuthorFormatMessage & {
  formatOptionsProps?: Partial<
    Record<
      AuthorFormatMessageOptionsKeys,
      Record<DataAttributeKey, string | number | undefined> & {
        href?: string // TODO Remove this field. Cheat to remove link when wrapper is anchor html tag
        className?: string
        style?: CSSProperties
      }
    >
  >
}
export const CardArticleAuthorName: FC<CardArticleAuthorNameProps> = (
  props,
) => {
  const { intlKey, formatOptions, formatOptionsProps } = props
  const {
    author_name,
    expert_display_name,
    fact_check_display_name,
    specialty,
    organisation,
    post_modified,
  } = formatOptions || {}
  const {
    author_name: formatOptionsPropsAuthorName,
    expert_display_name: formatOptionsPropsExpertDisplayName,
    fact_check_display_name: formatOptionsPropsFactCheckDisplayName,
    specialty: formatOptionsPropsSpecialty,
    organisation: formatOptionsPropsOrganisation,
    post_modified: formatOptionsPropsPostModified,
  } = formatOptionsProps || {}
  const { formatMessage: f } = useIntl()
  const { locale } = useRouterExtend()
  const currentDomain = useMemo(() => getHelloSitesUrl(locale), [locale])
  const theme = useMantineTheme()

  const formatOptionsComp = useCallback(
    (props: any = {}) => {
      const { href } = props
      const Comp = !!href ? Link : 'span'
      const propsComp = { ...props }
      if (!href) {
        delete propsComp['href']
        delete propsComp['data-event-category']
        delete propsComp['data-event-action']
        delete propsComp['data-event-label']
      }
      return <Comp {...propsComp} />
    },
    [currentDomain],
  )

  return (
    <>
      {f(
        { id: intlKey },
        {
          author_name: (
            <span
              style={{
                fontWeight: FontWeight.halfBold,
                color: theme.colors.gray[8],
              }}
            >
              {formatOptionsComp({
                ...author_name,
                ...formatOptionsPropsAuthorName,
              })}
            </span>
          ),
          expert_display_name: (
            <span
              style={{
                fontWeight: FontWeight.halfBold,
                color: theme.colors.gray[8],
              }}
            >
              {formatOptionsComp({
                ...expert_display_name,
                ...formatOptionsPropsExpertDisplayName,
              })}
            </span>
          ),
          fact_check_display_name: (
            <span
              style={{
                fontWeight: FontWeight.halfBold,
                color: theme.colors.gray[8],
              }}
            >
              {formatOptionsComp({
                ...fact_check_display_name,
                ...formatOptionsPropsFactCheckDisplayName,
              })}
            </span>
          ),
          specialty: formatOptionsComp({
            ...specialty,
            ...formatOptionsPropsSpecialty,
          }),
          organisation: formatOptionsComp({
            ...organisation,
            ...formatOptionsPropsOrganisation,
          }),
          post_modified: formatOptionsComp({
            ...post_modified,
            ...formatOptionsPropsPostModified,
          }),
        },
      )}
    </>
  )
}
